import { render } from "./ExpertStatisticsHome.vue?vue&type=template&id=1fad3f45"
import script from "./ExpertStatisticsHome.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsHome.vue?vue&type=script&lang=js"

import "./ExpertStatisticsHome.vue?vue&type=style&index=0&id=1fad3f45&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__